const RECOGNISED_SUPPLIER_KEYS = new Set(['deanta', 'jb-kind', 'lpd', 'pm-mendes']);

function getRecognisedSupplierKey(supplierDelivery, locationName) {
  if (!supplierDelivery || typeof supplierDelivery.normalizeSupplierName !== 'function') {
    return null;
  }

  const supplierKey = supplierDelivery.normalizeSupplierName(locationName);
  return RECOGNISED_SUPPLIER_KEYS.has(supplierKey) ? supplierKey : null;
}

function renderLocationDeliveryHtml(options) {
  const settings = options || {};
  const locationName = String(settings.locationName || '').trim();
  if (locationName.toLowerCase() === 'door 2 door handles') {
    return settings.storeMessage || '';
  }

  const supplierDelivery = settings.supplierDelivery;
  const supplierKey = getRecognisedSupplierKey(supplierDelivery, locationName);
  if (!supplierKey) return 'Delivery options calculated at checkout';

  const policy = supplierDelivery.getSupplierDeliveryPolicy(locationName, {
    vatMode: settings.vatMode,
    vatRate: settings.vatRate,
    moneyFormat: settings.moneyFormat,
  });
  if (!policy) return 'Delivery options calculated at checkout';

  const badges = settings.badges || {};
  const escapeHtml = (value) => String(value == null ? '' : value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;',
  })[character]);
  const collectionPolicies = Array.isArray(policy.collectionLocations) ? policy.collectionLocations : [];

  if (settings.compactPresentation) {
    const deliveryCopy = `${escapeHtml(policy.firstDoorCharge.formatted)} first door · ${escapeHtml(policy.additionalDoorCharge.formatted)} each additional door`;
    const deliveryRow = `<li class="delivery-estimate__row delivery-estimate__row--home"><img class="delivery-estimate__icon" src="${escapeHtml(badges.standard)}" alt=""><div class="delivery-estimate__content"><div class="delivery-estimate__primary">Home Delivery · ${escapeHtml(policy.leadTime)}</div><div class="delivery-estimate__secondary">${deliveryCopy}</div></div></li>`;
    const collectionRow = collectionPolicies.length ? `<li class="delivery-estimate__row delivery-estimate__row--collection"><img class="delivery-estimate__icon" src="${escapeHtml(badges.clickAndCollect)}" alt=""><div class="delivery-estimate__content"><div class="delivery-estimate__primary">Free Click &amp; Collect</div>${collectionPolicies.map((location) => (
      `<div class="delivery-estimate__location">${escapeHtml(location.name)}, ${escapeHtml(location.postcode)}</div>`
    )).join('')}</div></li>` : '';

    return `<ul class="delivery-estimate__compact">${deliveryRow}${collectionRow}</ul>`;
  }

  const collectionLocations = collectionPolicies.map((location) => {
    const readiness = location.secondaryMessage ? ` — ${escapeHtml(location.secondaryMessage)}` : '';
    return `${escapeHtml(location.name)}, ${escapeHtml(location.postcode)} — FREE${readiness}`;
  }).join(' or ');

  return `<img src="${escapeHtml(badges.standard)}" alt="Home Delivery"> Home Delivery in ${escapeHtml(policy.leadTime)} from ${escapeHtml(policy.firstDoorCharge.formatted)} ${escapeHtml(policy.vatLabel)} plus ${escapeHtml(policy.additionalDoorCharge.formatted)} ${escapeHtml(policy.vatLabel)} per additional Door<br><img src="${escapeHtml(badges.clickAndCollect)}" alt="Click and Collect"> Free Click &amp; Collect from ${collectionLocations}`;
}

function normaliseAvailableQuantity(value) {
  const quantity = Number(value);
  return Number.isFinite(quantity) && quantity >= 0 ? Math.floor(quantity) : 0;
}

function getSpecialOrderDecision(options) {
  const settings = options || {};
  const requestedQuantity = Math.max(1, parseInt(settings.requestedQuantity, 10) || 1);
  const availableQuantity = normaliseAvailableQuantity(settings.availableQuantity);
  const leadTimeDays = Number(settings.specialOrderDays);

  return {
    availableQuantity,
    // If any units exceed current stock, the displayed lead time applies to the
    // whole order so that we never promise a split shipment or mixed lead times.
    isMadeToOrder: Number.isFinite(leadTimeDays) && leadTimeDays > 0 && requestedQuantity > availableQuantity,
    leadTimeDays: Number.isFinite(leadTimeDays) && leadTimeDays > 0 ? leadTimeDays : null,
  };
}

if (typeof module === 'object' && module.exports) {
  module.exports = {
    getRecognisedSupplierKey,
    getSpecialOrderDecision,
    normaliseAvailableQuantity,
    renderLocationDeliveryHtml,
  };
}

if (typeof document !== 'undefined') document.addEventListener('DOMContentLoaded', () => {
   const vatRate = Number(window?.theme?.settings?.vat_rate_percentage || 0);
  const vatDenominator = 100 + vatRate;
  const resolveMoneyFormat = () => {
    if (typeof Shopify !== 'undefined' && typeof Shopify.money_format === 'string') {
      return Shopify.money_format;
    }
    if (typeof theme !== 'undefined' && theme.settings && typeof theme.settings.money_with_currency_format === 'string') {
      return theme.settings.money_with_currency_format;
    }
    return '{{amount}}';
  };
  const vatMoneyFormat = resolveMoneyFormat();
  const vatMoneyFormatAttr = vatMoneyFormat.replace(/"/g, '&quot;');
  const formatVatCents = (cents) => {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, vatMoneyFormat);
    }
    if (typeof formatMoney === 'function') {
      return formatMoney(cents, vatMoneyFormat);
    }
    return (cents / 100).toFixed(2);
  };
  const toCents = (value) => Math.max(0, Math.round(Number(value) || 0));
  const calcExclusiveFromIncCents = (incCents) => {
    if (!vatDenominator) {
      return incCents;
    }
    return Math.round((incCents * 100) / vatDenominator);
  };
  const getVatPriceMarkup = (incCents) => {
    const inc = toCents(incCents);
    const ex = calcExclusiveFromIncCents(inc);
    return `<span class="vat-price-value" data-price-inc="${inc}" data-price-ex="${ex}" data-money-format="${vatMoneyFormatAttr}">${formatVatCents(inc)}</span>`;
  };
  const FREE_DELIVERY_THRESHOLD_CENTS = 4500;
  const EXPRESS_DELIVERY_PRICE_CENTS = 995;
  const PM_MENDES_FREE_DELIVERY_THRESHOLD_CENTS = 100000;
  const DEFAULT_LOCATION_NAME = 'Door 2 Door Handles';
  const variantLocationMap = window.variantLocationMap || {};
  const freeShippingElement = document.querySelector(
    '.product-add-to-cart-container free-shipping'
  );
  const freeShippingMinimums = window.freeShippingLocationMinimums || {};
  const inventoryText = document.querySelector(
    '.product-information--inner .product-inventory-notice--wrapper'
  );
  const qtyInput = document.querySelector('.product-add-to-cart-container .qty');
  if (!qtyInput) return;
  const sectionIdMatch = qtyInput.id.match(/Quantity-(.*)/);
  const productSection = qtyInput.closest('product-form');
  const sectionId = sectionIdMatch
    ? sectionIdMatch[1]
    : productSection?.dataset.section || '';
   const estimateId = 'delivery-estimate-' + sectionId;
  const useMobileEstimate = window.matchMedia('(max-width: 768px)').matches;
  const msgEl = document.getElementById(
    estimateId + (useMobileEstimate ? '-mobile' : '-desktop')
  ) || document.getElementById(estimateId);
  if (!msgEl) return;
   // Legacy store-item estimates have complete server-rendered policy text and
  // their own basket/VAT updater. Compact 3-column estimates are variant-aware.
  if (msgEl.matches('[data-store-delivery-policy]:not([data-presentation="compact"])')) return;
   if (inventoryText && msgEl.parentElement) {
    msgEl.parentElement.insertBefore(inventoryText, msgEl);
  }
  const badgeStock =
    msgEl.dataset.badgeStock ||
    'https://www.door2doorhandles.co.uk/cdn/shop/t/3/assets/badge_Stock.svg';
  const badgeSpecialOrder =
    msgEl.dataset.badgeSpecialOrder ||
    'https://www.door2doorhandles.co.uk/cdn/shop/t/3/assets/badge_SpecialOrder.svg';
  const badgeStandard =
    msgEl.dataset.badgeStandard ||
    'https://www.door2doorhandles.co.uk/cdn/shop/t/3/assets/badge_StandardDelivery.svg';
  const badgeExpress =
    msgEl.dataset.badgeExpress ||
    'https://www.door2doorhandles.co.uk/cdn/shop/t/3/assets/badge_ExpressDelivery.svg';
    const badgeClickAndCollect =
    msgEl.dataset.badgeClickCollect ||
    'https://www.door2doorhandles.co.uk/cdn/shop/t/3/assets/badge_ClickAndCollect.svg';


  const inventoryTotals = window.variantAvailableWithSupplierStock || {};
  const specialOrderMap = window.variantSpecialOrderDays || {};

  function getSupplierStock(variant) {
    let supplier = parseInt(
      variant?.metafields?.supplier?.supplier_stock || 0,
      10
    );

     if (!supplier) {
      const total = parseInt(inventoryTotals[String(variant.id)] || 0, 10);
      if (!isNaN(total)) {
        const inv = parseInt(variant.inventory_quantity || 0, 10);
        supplier = Math.max(total - inv, 0);
      }
    }
    return supplier;
  }

 function normaliseLocationValue(value) {
    if (typeof value === 'string') {
      return value.trim();
    }
    if (value && typeof value.toString === 'function') {
      return value.toString().trim();
    }
    return '';
  }

  function getVariantLocationName(variant) {
    const id = variant?.id ? String(variant.id) : '';
    if (id && Object.prototype.hasOwnProperty.call(variantLocationMap, id)) {
      const mapped = normaliseLocationValue(variantLocationMap[id]);
      if (mapped) {
        return mapped;
      }
    }
    return DEFAULT_LOCATION_NAME;
  }

   function getLocationMinimumCents(locationName) {
    const key = normaliseLocationValue(locationName).toLowerCase();
    if (key && Object.prototype.hasOwnProperty.call(freeShippingMinimums, key)) {
      return toCents(freeShippingMinimums[key]);
    }
    if (Object.prototype.hasOwnProperty.call(freeShippingMinimums, 'default')) {
      return toCents(freeShippingMinimums.default);
    }
    if (key === 'pm mendes') {
      return PM_MENDES_FREE_DELIVERY_THRESHOLD_CENTS;
    }
    return FREE_DELIVERY_THRESHOLD_CENTS;
  }

  function getLocationTotals(locationName) {
    const totalsMap = window.cartLocationTotals || {};
    const key = normaliseLocationValue(locationName).toLowerCase();
    if (key && Object.prototype.hasOwnProperty.call(totalsMap, key)) {
      return totalsMap[key];
    }
    if (Object.prototype.hasOwnProperty.call(totalsMap, 'default')) {
      return totalsMap.default;
    }
    return { total_inc: 0, total_ex: 0 };
  }

  function updateFreeShippingBar(locationName) {
    if (!freeShippingElement) {
      return;
    }

    const normalizedLocation = normaliseLocationValue(locationName) || DEFAULT_LOCATION_NAME;
    const totals = getLocationTotals(normalizedLocation) || {};
    const totalsInc = toCents(totals.total_inc);
    let totalsEx = toCents(totals.total_ex);
    const minimumInc = getLocationMinimumCents(normalizedLocation);
    const minimumEx = calcExclusiveFromIncCents(minimumInc);

    if (!Number.isFinite(totalsEx)) {
      totalsEx = calcExclusiveFromIncCents(totalsInc);
    }

    freeShippingElement.setAttribute('data-location-name', normalizedLocation);
    freeShippingElement.setAttribute('data-minimum', minimumInc);
    freeShippingElement.setAttribute('data-minimum-inc', minimumInc);
    freeShippingElement.setAttribute('data-minimum-ex', minimumEx);
    freeShippingElement.setAttribute('data-cart-total', totalsInc);
    freeShippingElement.setAttribute('data-cart-total-inc', totalsInc);
    freeShippingElement.setAttribute('data-cart-total-ex', totalsEx);
  }

  function getDefaultFreeDeliveryThreshold() {
    const minimum = getLocationMinimumCents(DEFAULT_LOCATION_NAME);
    return minimum || FREE_DELIVERY_THRESHOLD_CENTS;
  }

   
  function getMessageHtml(qty, variant, locationName) {
    const inventory = parseInt(variant.inventory_quantity || 0, 10);
    const supplier = getSupplierStock(variant);
    const location = normaliseLocationValue(locationName) || DEFAULT_LOCATION_NAME;
    const supplierDelivery = window.SupplierDelivery;
    const supplierKey = getRecognisedSupplierKey(supplierDelivery, location);
    if (supplierKey) {
      if (qty > inventory && qty > supplier) {
        return 'Please call for next availability date';
      }
        return renderLocationDeliveryHtml({
        locationName: location,
        supplierDelivery,
        vatMode: document.documentElement.dataset.vatDisplay === 'ex' ? 'ex' : 'inc',
        vatRate,
        moneyFormat: vatMoneyFormat,
        badges: { standard: badgeStandard, clickAndCollect: badgeClickAndCollect },
        compactPresentation: msgEl.dataset.presentation === 'compact',
      });
    }


    if (qty <= inventory) {
      return 'Delivered in 1-2 Working Days';
    }
    if (qty > inventory && qty <= supplier) {
         return `<img src="${badgeStandard}" alt="Standard Delivery"> Free Delivery over ${getVatPriceMarkup(getDefaultFreeDeliveryThreshold())} in 2-3 Working Days<br><img src="${badgeExpress}" alt="Express Delivery"> Next Working Day Delivery from ${getVatPriceMarkup(EXPRESS_DELIVERY_PRICE_CENTS)} (Order before 1PM)`;
    }
    if (qty > inventory && qty > supplier) {
      return 'Please call for next availability date';
    }
     return '';
  }

  function getAvailableText(variant) {
    const inventory = parseInt(variant.inventory_quantity || 0, 10);
    const supplier = getSupplierStock(variant);
    const total = inventory + supplier;

    if (total < 0) return '';

    const qtyText = total > 100 ? '100+' : total;
    return `${qtyText} Available`;
  }

  function update(variant) {
    const qty = parseInt(qtyInput.value, 10) || 1;
    const varData = variant || window.CurrentVariant || {};
    const compactPresentation = msgEl.dataset.presentation === 'compact';
    const specialDays =
      specialOrderMap[String(varData.id)] ||
      varData?.metafields?.supplier?.supplier_special_order_days ||
      '';
     const locationName = getVariantLocationName(varData);
    const specialOrder = getSpecialOrderDecision({
      requestedQuantity: qty,
      availableQuantity: inventoryTotals[String(varData.id)],
      specialOrderDays: specialDays,
    });
    if (specialOrder.isMadeToOrder) {
      msgEl.innerHTML = `<img src="${badgeSpecialOrder}" alt="Special Order"> Made to Order - ${specialOrder.leadTimeDays} Day Lead Time`;
      updateFreeShippingBar(locationName);
      return;
    }
    const message = getMessageHtml(qty, varData, locationName);
    let html = '';
    const availability = compactPresentation ? '' : getAvailableText(varData);
    if (availability) {
      html += `<img src="${badgeStock}" alt="Stock"> ${availability}<br>`;
    }
    html += message;
    msgEl.innerHTML = html;
    
    updateFreeShippingBar(locationName);
  }

  qtyInput.addEventListener('change', () => update());
  qtyInput.addEventListener('input', () => update());

  document.addEventListener('globalVariantIdUpdated', (e) => {
    if (e.detail && e.detail.variant) {
      update(e.detail.variant);
    } else {
      update();
    }
  });

  document.addEventListener('vat:change', () => update());

  

  update();
});
